import { v4 as uuidv4 } from "uuid";
import { photoshop } from "../globals";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchGatewayInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Camera Multi-Angle";

const callCameraMultiAngle = async (
	messageId: string,
	jwt: string,
	rotation: number,
	elevation: number,
	distance: number,
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				inputs: {
					$img: imageBase64,
					$rotation: rotation,
					$elevation: elevation,
					$distance: distance,
				},
				tool_document_id,
				jwt,
			};
			return fetchCameraMultiAngle(data, executionContext, messageId);
		},
	});

	if (success) {
		const doc = photoshop.app.activeDocument;
		if (doc) {
			postToRenderer([
				{
					key: "documentInfoChanged",
					id: uuidv4(),
					values: {
						width: doc.width,
						height: doc.height,
					},
				},
			]);
		}
	}

	return success;
};

export async function fetchCameraMultiAngle(
	params: {
		inputs: {
			$img: string;
			$rotation: number;
			$elevation: number;
			$distance: number;
		};
		tool_document_id: string;
		jwt: string;
	},
	executionContext: any,
	messageId: string,
): Promise<string | false> {
	return fetchGatewayInferenceJob(params, executionContext, messageId);
}

export function useListenCameraMultiAngleMessage() {
	useListenFromRenderer([
		{
			key: "cameraMultiAngle",
			onMessage: async (message) => {
				const success = await callCameraMultiAngle(
					message.id,
					message.values.jwt,
					message.values.rotation,
					message.values.elevation,
					message.values.distance,
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
